import { useState, useContext } from 'react'
import { TbPackageOff } from 'react-icons/tb'
import { AiOutlineCloudSync } from 'react-icons/ai'
import AddLabOffice from '../AddLabOffice'
import SyncSap from '../SyncSap'
import MachineMaster from '../Machine'
import UserContext from '../../contexts/UserContext'

import UnAuthorizedPage from '../../components/UnAuthorizedPage'
import { MdOutlinePrecisionManufacturing } from 'react-icons/md'

export default function Masters() {
  const [ selectedMenu, setSelected ] = useState<string>('SYNC')

  const userCon = useContext(UserContext)
  const readOnly = userCon.readOnly

  return readOnly ? <UnAuthorizedPage isBack={false} /> : <div className="flex ">
    <div className=" basis-1/6 h-screen px-2 bg-[#67798f]">
      <ul className="pt-2 ">
        <li className={`flex items-center p-2 text-white cursor-pointer gap-x-4 hover:bg-red-500 rounded-md mt-2${selectedMenu === 'SYNC' ? ' bg-red-500':''}`}
          onClick={() => setSelected('SYNC')}>
          <AiOutlineCloudSync size={22} className='text-white '/>
          <span>Sync Order</span>
        </li>
        <li className={`flex items-center p-2 text-white cursor-pointer gap-x-4 hover:bg-red-500 rounded-md mt-2${selectedMenu === 'REASONCODES' ? ' bg-red-500':''}`}
          onClick={() => setSelected('REASONCODES')}>
          <TbPackageOff size={22} className='text-white '/>
          เพิ่ม Reason Code
        </li>
        <li className={`flex items-center p-2 text-white cursor-pointer gap-x-4 hover:bg-red-500 rounded-md mt-2${selectedMenu === 'MACHINE' ? ' bg-red-500':''}`}
          onClick={() => setSelected('MACHINE')}>
          <MdOutlinePrecisionManufacturing size={22} className='text-white '/>
          จัดการ Machine
        </li>
      </ul>
    </div>
    <div className="p-4 basis-5/6">
      {/* {selectedMenu === 'ORDERS' ? <OrderMaster /> : null} */}
      {selectedMenu === 'REASONCODES' ? <AddLabOffice /> : null}
      {selectedMenu === 'SYNC' ? <SyncSap /> : null}
      {selectedMenu === 'MACHINE' ? <MachineMaster /> : null}
    </div>
  </div>
}